// eslint-disable-next-line no-shadow
enum EConfigurableListModal {
    ColumnManagement = 'ColumnManagement',
    CreateReport = 'CreateReport',
    ConfirmDeleteReport = 'ConfirmDeleteReport',
}

export default EConfigurableListModal
